import { useEffect, useState, useContext } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { contextWeb3 } from "../contexts/ProviderWeb3";
import { contextTheme } from "../contexts/ProviderTheme";
import { URI, URL_INFURA, cortador } from "../helpers";
import axios from "axios";
import BannerInfo01 from "./BannerInfo01";
import { contextProvider } from "../Providers";
import { Carousel } from "react-carousel-minimal";
import ButtonToCart from "./ButtonToCart";

const captionStyle = {
  fontSize: "2em",
  fontWeight: "bold",
};
const slideNumberStyle = {
  fontSize: "10px",
  fontWeight: "bold",
};
export default function ProductDetail({ addToCart }) {
  let navigate = useNavigate();
  const { setFilterCategory } = useContext(contextProvider);
  const { theme } = useContext(contextTheme);
  const { balanceStore } = useContext(contextWeb3);
  const params = useParams();
  const { id } = params;
  const [product, setProduct] = useState({});
  const [category, setCategory] = useState({});
  const [data, setData] = useState([{}]);
  const [loading, setLoading] = useState(true);

  const styles = {
    font: {
      color: !theme ? "#333" : "#FFF",
      fontSize: "1.4rem",
    },
    coin: {
      fontSize: ".7rem",
    },
    discount: {
      backgroundColor: "#f8f8f8",
      padding: "10px 15px",
      fontSize: ".9rem",
      color: "#333",
      marginBottom: "20px",
    },
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    const getProduct = async () => {
      const { data } = await axios.get(`${URI}products/${id}`);

      setProduct({
        category: data.category[0].title,
        codebar: data.codebar,
        discount: data.discount,
        id: data._id,
        id_categoria: data.category[0]._id,
        minimum_amount_discount: data.minimum_amount_discount,
        price: data.price,
        title: data.title,
        url_image_1: data.url_image_1,
        url_image_2: data.url_image_2,
        url_image_3: data.url_image_3,
      });

      setCategory(data.category[0]);

      const arr = [];

      arr.push({
        image: `${URL_INFURA}${data.url_image_1}`,
        caption: ``,
      });

      if (data.url_image_2 !== "") {
        arr.push({
          image: `${URL_INFURA}${data.url_image_2}`,
          caption: ``,
        });
      }

      if (data.url_image_3 !== "") {
        arr.push({
          image: `${URL_INFURA}${data.url_image_3}`,
          caption: ``,
        });
      }

      setData(arr);

      setLoading(false);
    };

    getProduct();
  }, [id]);

  const filterByCategory = (id) => {
    setFilterCategory(id);
    return navigate("/");
  };

  return (
    <>
      {!loading ? (
        <div>
          <div class="breadcrumb">
            <ul>
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <a
                  style={{ cursor: "pointer" }}
                  onClick={() => filterByCategory(category["_id"])}
                >
                  {category["title"]}
                </a>
              </li>
              <li>{cortador(product.title)}</li>
            </ul>
          </div>

          <div className="productDetailContainer">
            <div style={{ textAlign: "center" }}>
              <Carousel
                data={data}
                time={2000}
                width="850px"
                height="300px"
                captionStyle={captionStyle}
                radius="10px"
                slideNumber={true}
                slideNumberStyle={slideNumberStyle}
                captionPosition="bottom"
                automatic={false}
                dots={true}
                pauseIconColor="white"
                pauseIconSize="40px"
                slideBackgroundColor="darkgrey"
                slideImageFit="cover"
                thumbnails={true}
                thumbnailWidth="100px"
                style={{
                  textAlign: "center",
                  maxWidth: "850px",
                  maxHeight: "500px",
                  margin: "40px auto",
                }}
              />
            </div>

            <div>
              <h1>{product.title}</h1>
              <div className="price" style={{ marginBottom: "20px" }}>
                <span className="actual" style={styles.font}>
                  Price: {product.price}{" "}
                  <span style={styles.coin}>DAI/ USDT/ BUSD</span>
                </span>
              </div>

              {product.discount ? (
                <div style={styles.discount}>
                  Get{" "}
                  {`${product.discount}% discount if you have in your wallet`}
                  {` ${
                    product.minimum_amount_discount
                  } $STORE -- You have ${Number(balanceStore).toFixed(
                    2
                  )} $STORE`}
                </div>
              ) : null}

              <ButtonToCart product={product} addToCart={addToCart} />
            </div>
          </div>
        </div>
      ) : (
        "Cargando ..."
      )}

      <BannerInfo01 />
    </>
  );
}
